<template>
    <div class="input">
      <label>{{ label }}</label>
      <input type="date" v-bind:value="innerValue" v-on:input="updateValue($event.target.value)" />
    </div>
</template>

<script>
import moment from 'moment';

const stringToDate = (s) => {
  const m = moment(s, 'YYYY-MM-DD');
  const d = m.toDate();
  return d;
};

const dateToString = (date) => {
  const m = moment(date);
  const s = m.format('YYYY-MM-DD');
  return s;
};

export default {
  name: 'DateInput',
  props: {
    label: String,
    value: Date,
  },
  data() { return { innerValue: dateToString(this.value) }; },
  methods: {
    updateValue(v) {
      this.$emit('input', stringToDate(v));
      this.innerValue = v;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
